import React from "react"

import {Deal} from "@irati/types"
import Markdown from "@irati/ui/src/Markdown"
import {getThumbnailImage} from "@irati/utils/images"
import Close from "@irati/ui/src/Close"

import {CenteredH3, CenteredThumbnailImage, DealDescriptionText} from "./styled"
import DescriptionModal from "../styled/DescriptionModal"

interface Props {
  deal: Deal
  onHide: () => void
}

const DealDescriptionModal = ({deal, onHide}: Props) => {
  return (
    <DescriptionModal dialogClassName="dealDescriptionPopUp" backdrop backdropClassName="consistentBackdrop" show={!!deal} onHide={onHide}>
      <CenteredThumbnailImage src={getThumbnailImage(deal.thumbnailImage)} />
      <Close top="20px" right="20px" onClick={onHide} />
      <CenteredH3 className="push--bottom">{deal.header}</CenteredH3>
      <DealDescriptionText>
        <Markdown source={deal.description} />
      </DealDescriptionText>
    </DescriptionModal>
  )
}

export default DealDescriptionModal
